import tabbedReveal from '../tabbedReveal';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    tabbedReveal().init();
  },
};



// WEBPACK FOOTER //
// ./scripts/js/source/routes/TabbedContent.js